import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { dehydrate, QueryClient } from '@tanstack/react-query';
import { Global } from '@emotion/react';
import CommonLayout from '~components/CommonLayout';
import PageMeta from '~components/metas/PageMeta';
import RailEuropeSearch from '~features/RailEuropeSearch/Search';
import { useDetermineMobile, useWebView } from '@myrealtrip/device-detect';
import { checkMobileServerSideProps } from '~serverSideProps/checkMobile';
import { memberServerSideProps } from '~serverSideProps/member';
import { queryParamsServerSideProps } from '~serverSideProps/queryParams';
import { webViewServerSideProps } from '~serverSideProps/webView';
import { RailEuropeTrainQueryParam } from '~types/queryParam';
import { composeServerSideProps } from '~utils/composeServerSideProps';
import { searchStyle } from '~styles/searchStyle';
import { TRANSPORTATION_ORIGIN } from '~config/publicEnv';

interface Props {
  queries: RailEuropeTrainQueryParam;
}

const TransportationSearch: NextPage<Props> = ({ queries }) => {
  const isMobile = useDetermineMobile();
  const { isWebView } = useWebView();
  const { asPath } = useRouter();

  return (
    <>
      <PageMeta ogUrl={`${TRANSPORTATION_ORIGIN}${asPath || '/search/train/europe'}`} />
      <CommonLayout hideHeader={isMobile} hideFooter={isWebView}>
        <Global styles={searchStyle()} />
        <RailEuropeSearch queries={queries} />
      </CommonLayout>
    </>
  );
};

async function TransportationSearchGetServerSideProps() {
  const queryClient = new QueryClient();

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  };
}

export const getServerSideProps = composeServerSideProps([
  memberServerSideProps,
  queryParamsServerSideProps,
  checkMobileServerSideProps,
  webViewServerSideProps,
  TransportationSearchGetServerSideProps,
]);

export default TransportationSearch;
